import { render, staticRenderFns } from "./groupsTable.vue?vue&type=template&id=104ec91c&"
import script from "./groupsTable.vue?vue&type=script&lang=js&"
export * from "./groupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTd,QBtn,QPagination} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd,QBtn,QPagination})
